import { Edit24Filled } from "@fluentui/react-icons";
import React from "react";
import Button from "components/Buttons/Button";
import { StripeBrands } from "enum/common";
import Diners from "assets/diners.png";
import Amex from "assets/amex.png";
import Discover from "assets/discover.png";
import Master from "assets/master.png";
import Jcb from "assets/jcb.png";
import Visa from "assets/visa.png";
import EftPos from "assets/eftpos.png";
import UnionPay from "assets/UnionPay.png";
import Unknown from "assets/defaultCreditCard.png";
import { DefaultPaymentMethodType } from "containers/PaymentMethodManagement/types";

interface ICustomerCradDetailsProps {
  defaultPaymentMethod?: DefaultPaymentMethodType;
  onEdit: () => void;
}

const CustomerCradDetails: React.FC<ICustomerCradDetailsProps> = ({
  defaultPaymentMethod,
  onEdit,
}) => {
  const getCardLogo = (brand: string) => {
    const iconClass = "inline-block w-[56px] h-[42px]";
    switch (brand) {
      case StripeBrands.VISA:
        return <img src={Visa} className={iconClass} />;
      case StripeBrands.AMEX:
        return <img src={Amex} className={iconClass} />;
      case StripeBrands.DINERS:
        return <img src={Diners} className={iconClass} />;
      case StripeBrands.MASTER:
        return <img src={Master} className={iconClass} />;
      case StripeBrands.JCB:
        return <img src={Jcb} className={iconClass} />;
      case StripeBrands.DISCOVER:
        return <img src={Discover} className={iconClass} />;
      case StripeBrands.EFTPOS:
        return <img src={EftPos} className={iconClass} />;
      case StripeBrands.UNIONPAY:
        return <img src={UnionPay} className={iconClass} />;
      case StripeBrands.UNK:
        return <img src={Unknown} className={iconClass} />;
      default:
        return <img src={Unknown} className={iconClass} />;
    }
  };
  return (
    <div className="flex flex-col gap-2 md:gap-4">
      <div className="text:xl md:text-2xl text-darkBlue">Saved Cards</div>
      <div className="bg-white md:p-5 md:py-5 p-4 flex gap-4 w-full">
        <div>{getCardLogo(defaultPaymentMethod?.brand || "")}</div>
        <div className="flex-1 flex justify-center flex-col">
          <div className="flex gap-6">
            <div>{defaultPaymentMethod?.name}</div>
          </div>
          <div>
            <div className="text-opacity-60 flex text-black self-center">{`**** **** **** ${defaultPaymentMethod?.last4}`}</div>
          </div>
        </div>{" "}
        <div className="flex">
          <div className="md:block hidden">
            <Button label={"Update"} onClick={onEdit} customClass="w-[100px]" />
          </div>
          <div className="md:hidden flex items-center">
            <Edit24Filled
              onClick={onEdit}
              className="justiofy-end text-trueBlue"
              color=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerCradDetails;
